<template>
    <div class="list">
      <div class="storyCon">
        <div class="tab">
          <div class="tabItem">
            <span :class="{'active': currentType == 1}" @click="changeTab(1)">短视频 VLOG</span>
            <span :class="{'active': currentType == 2}" @click="changeTab(2)">图片故事 PLOG</span>
          </div>
          <div class="rightSearch">
            <div class="searchCon">
              <input type="text" v-model="searchInput">
              <img src="../img/m/search.png" alt="" class="searchIcon" @click="search">
              <div class="currentType" @click="isShowSearchType = !isShowSearchType">
                <span v-if="search_type == 1">
                  作品名
                </span>
                <span v-if="search_type == 2">
                  提供者
                </span>
                <img src="../img/m/searchTypeTriangle.png" alt="" class="triangle">
              </div>
              <div  class="itemList" v-show="isShowSearchType">
                <span  class="item" @click="chooseType(1)">作品名</span>
                <span  class="item" @click="chooseType(2)">提供者</span>
              </div>
            </div>
            <div class="categoryCon">
              <div @click="isShowCategory = !isShowCategory">
                <img src="../img/m/filter.png" alt="" class="filter">
                <span>{{currentCategory.category_name}}</span>
                <img src="../img/m/searchTypeTriangle.png" alt="" class="triangle">
              </div>
              <div class="categoryList" v-show="isShowCategory">
                <div v-for="item in categoryList" :key="item.category_id" class="item" @click="chooseCategory(item)">
                  {{item.category_name}}
                </div>
              </div>
            </div>
            <div class="categoryCon topicCon" v-if="topicList.length">
              <div @click="isShowTopic = !isShowTopic">
                <span>{{currentTopic.topic_name}}</span>
                <img src="../img/m/searchTypeTriangle.png" alt="" class="triangle">
              </div>
              <div class="categoryList topicList" v-show="isShowTopic">
                <div v-for="item in topicList" :key="item.topic_id" class="item" @click="chooseTopic(item)">
                  {{item.topic_name}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="storyList videoList" v-show="currentType == 1">
          <div class="item" v-for="item in videoList" :key="item.works_id" @click="toDetail(item, 1)">
            <img :src="'https://collection2021-cos.chineseplus.net/'+item.video_cover" alt="" class="cover">
            <div class="info">
              <div class="title">
                {{item.title}}
              </div>
              <div class="author">
                {{item.user_name}}
              </div>
              <div class="country">
                {{item.cn}}
              </div>
              <img src="../img/m/video_btn.png" alt="" class="play">
              <div class="like_num">
                <img src="../img/m/zan.png" alt="">
                <div>
                  {{item.like_num}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="storyList photoList" v-show="currentType == 2">
          <div class="item" v-for="item in photoList" :key="item.works_id" @click="toDetail(item, 2)">
            <img :src="'https://collection2021-cos.chineseplus.net/'+item.cover" alt="" class="cover">
            <div class="info">
              <div class="title">
                {{item.title}}
              </div>
              <div class="author">
                {{item.user_name}}
              </div>
              <div class="country">
                {{item.cn}}
              </div>
              <img src="../img/m/video_btn.png" alt="" class="play">
              <div class="like_num">
                <img src="../img/m/zan.png" alt="">
                <div>
                  {{item.like_num}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          ref="pagination"
          layout="prev, pager, next"
          class="pagination"
          :page-size="limit"
          :total="total"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          prev-text="上一页"
          next-text="下一页">
        </el-pagination>
      </div>
    </div>
</template>

<script>
export default {
    name: 'list',
    data: function () {
        return {
          videoList: [],
          photoList: [],
          page: 1,
          limit: 9,
          total: 0,
          currentType: 1,
          searchInput: '',
          topicList: [],
          categoryList: [],
          search_type: 1, // 1：作品名 2：用户名
          currentCategory: {
            category_id: '',
            category_name: '全部分类'
          },
          currentTopic: {
            topic_id: '',
            topic_name: '全部话题'
          },
          isShowSearchType: false,
          isShowCategory: false,
          isShowTopic: false,
        }
    },
    created() {
      this.getList(this.page, this.currentType)
      this.getCategoryList()
    },
    methods: {
      toDetail(detail, type) {
        var url = 'vlogdetail'
        if(type == 2) {
          url = 'plogdetail'
        }
        this.$router.push({
          path: url,
          query: {
            id: detail.works_id
          }
        })
      },
      search() {
        this.getList(this.page, this.currentType)
      },
      chooseType(type) {
        this.search_type = type
        this.isShowSearchType = false
      },
      // 选择分类
      chooseCategory(category) {
        this.currentCategory = category
        this.isShowCategory = false
        this.currentTopic = {
          topic_id: '',
          topic_name: '全部话题'
        }
        this.getTopicList(category.category_id)
        this.page = 1
        this.getList(this.page, this.currentType)
      },
      // 修改主题
      chooseTopic(topic) {
        this.currentTopic = topic
        this.isShowTopic = false
        this.page = 1
        this.getList(this.page, this.currentType)
      },
      // 获取话题列表
      getTopicList(category_id) {
        if(!category_id) {
          this.topicList = []
          return
        }
        this.$utils.get('/works/getTopic', {
          category_id
        }).then(res => {
          this.topicList = res.data
          this.topicList.unshift({
            topic_id: '',
            topic_name: '全部话题'
          })
        })
      },
      // 获取分类列表
      getCategoryList() {
        this.$utils.get('/works/getCategory').then(res => {
          console.log(res)
          this.categoryList = res.data
          this.categoryList.unshift({
            category_id: '',
            category_name: '全部分类'
          })
        })
      },
      routerTo(path) {
        this.$router.push(path)
      },
      // 切换tab
      changeTab(type) {
        this.currentType = type
        this.page = 1
        this.total = 0
        this.searchInput = ''
        this.getList(this.page, this.currentType)
      },
      // 分页
      handleCurrentChange(val) {
        this.page = val
        this.getList(this.page, this.currentType)
      },
      // 获取列表
      getList(page, type) {
        var data = {
          type,
          order: 1,
          pageSize: this.limit,
          page,
          keyword: this.searchInput,
          search_type: this.search_type
        }
        if(this.currentCategory.category_id) {
          data.category_id = this.currentCategory.category_id
        }
        if(this.currentCategory.topic_id) {
          data.topic_id = this.currentTopic.topic_id
        }
        this.$utils.get('/works/list', data).then(res => {
          if(type == 1) {
            this.videoList = res.data.list
          } else {
            this.photoList = res.data.list
          }
          this.total = res.data.total
        })
      },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.list {
    width: 1200px;
    margin: 50px auto 50px;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .storyCon {
      padding: 40px;
      box-sizing: border-box;
      background-color: #fff;
      .tab {
        .tabItem {
          font-size: 30px;
          margin-right: 20px;
          color: #818181;
          display: inline-block;
          span {
            margin-right: 40px;
            cursor: pointer;
            &:last-child {
              margin-right: 0;
            }
          }
          .active {
            color: #9576ef;
          }
        }
        .rightSearch {
          float: right;
          margin-top: -15px;
          font-size: 18px;
        }
        .searchCon {
          width: 259px;
          height: 60px;
          display: inline-block;
          border: 1px solid #9576ef;
          box-sizing: border-box;
          position: relative;
          input {
            outline: none;
            border: none;
            display: inline-block;
            height: 56px;
            margin-left: 50px;
            width: 110px;
          }
          .searchIcon {
            position: absolute;
            width: 30px;
            top: 14px;
            left: 18px;
          }
          .currentType {
            position: absolute;
            right: 10px;
            top: 20px;
            color: #9576ef;
            cursor: pointer;
            .triangle {
              width: 15px;
            }
          }
          .itemList {
            position: absolute;
            right: 0;
            bottom: -112px;
            z-index: 2;
            background-color: #fff;
            .item {
              cursor: pointer;
              width: 100px;
              height: 40px;
              border: 1px solid #9576ef;
              display: block;
              color: #9576ef;
              padding: 7px 15px;
              border-top: none;
              opacity: .6;
              line-height: 40px;
              text-decoration: none;
            }
          }
          
        }
        .categoryCon {
          width: 200px;
          display: inline-block;
          vertical-align: top;
          height: 60px;
          line-height: 60px;
          border: 1px solid #9576ef;
          box-sizing: border-box;
          position: relative;
          margin-left: 20px;
          color: #282828;
          cursor: pointer;
          font-size: 18px;
          
          span {
            display: inline-block;
            width: 122px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .filter {
            width: 32px;
            margin: 15px 5px 0 12px;
            vertical-align: top;
          }
          .triangle {
            width: 15px;
            float: right;
            margin: 27px 5px 0 5px;
          }
          .categoryList {
            position: absolute;
            right: 0;
            top: 60px;
            z-index: 2;
            background-color: #fff;
            .item {
              cursor: pointer;
              width: 200px;
              height: 60px;
              border: 1px solid #9576ef;
              display: block;
              color: #9576ef;
              padding: 7px 15px;
              border-top: none;
              opacity: .6;
              line-height: 40px;
              text-decoration: none;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              box-sizing: border-box;
            }
          }
        }
        .topicCon {
          width: 133px;
          span {
            width: 73px;
            margin-left: 10px;
          }
          .topicList {
            .item {
              width: 133px;
            }
          }
        }
      }
      .storyList {
        margin-top: 54px;
        .item {
          width: 360px;
          height: 226px;
          display: inline-block;
          margin-right: 20px;
          margin-bottom: 20px;
          vertical-align: top;
          position: relative;
          cursor: pointer;
          overflow: hidden;
          &:nth-child(3n) {
            margin-right: 0;
          }
          .cover {
            width: 100%;
            min-height: 100%;
          }
          .info {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.5);
            opacity: 0;
            transition: all linear 0.2s;
            &:hover {
              opacity: 1;
            }
            .title {
              font-size: 28px;
              color: #fff;
              margin-left: 19px;
              margin-top: 20px;
              width: 90%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .author,.country {
              font-size: 18px;
              margin-left: 19px;
              margin-top: 10px;
              color: #fff;
              width: 90%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .play {
              position: absolute;
              bottom: 20px;
              left: 19px;
              width: 40px;
            }
            .like_num {
              position: absolute;
              right: 20px;
              bottom: 20px;
              font-size: 36px;
              color: #fff;
              width: 42px;
              text-align: center;
              img {
                width: 42px;
              }
              div {
                min-width: 42px;
                float: right;
              }
            }
          }
        }
      }
    }
}
.pagination {
  text-align: center;
  margin-top: 40px;
}
</style>
